import { LinkTypeMap, PaperProps, Stack, StackProps, TypographyProps } from '@mui/material';
import React, { ElementType } from 'react';
import { LinkGroup, LinkGroupProps } from '../linkGroup';

export type LinkListProps = {
    links: LinkGroupProps[] | null | undefined
    withDropdown?: boolean
    alignLeft?: boolean
    enableIcons?: boolean
    forceLink?: boolean
    StackProps?: StackProps
    LinkGroupItemsStackProps?: StackProps
    LinkDropdownStackProps?: StackProps
    LinkDropdownPaperProps?: PaperProps
    relativeLinkComponent?: ElementType;
    headerComponent?: string
    LinkProps?: LinkTypeMap['props']
    LinkGroupItemsTypographyProps?: TypographyProps
    LinkGroupHeaderTypographyProps?: TypographyProps
    LinkGroupHeaderLinkProps?: LinkTypeMap['props']
    disableGroupDropDownIcon?: boolean
    onClick?: () => void
}

export function LinkList({
    links,
    withDropdown,
    StackProps,
    alignLeft,
    relativeLinkComponent,
    headerComponent,
    forceLink,
    LinkProps,
    LinkGroupItemsTypographyProps,
    LinkGroupHeaderLinkProps,
    LinkGroupHeaderTypographyProps,
    LinkGroupItemsStackProps,
    disableGroupDropDownIcon,
    LinkDropdownStackProps,
    LinkDropdownPaperProps,
    enableIcons,
    onClick
}: LinkListProps) {
    if (!links) return <></>

    return (
        <Stack gap={{ xs: 2, md: 4, lg: 6 }} {...StackProps}>
            {links.map((link, i) => {
                return (
                    <LinkGroup
                        key={i}
                        label={link.label}
                        url={link.url}
                        description={link.description}
                        links={link.links}
                        onClick={onClick}
                        withDropdown={withDropdown}
                        enableIcons={enableIcons}
                        LinkGroupItemsStackProps={LinkGroupItemsStackProps}
                        alignLeft={alignLeft}
                        forceLink={forceLink}
                        LinkDropdownPaperProps={LinkDropdownPaperProps}
                        disableGroupDropDownIcon={disableGroupDropDownIcon}
                        headerComponent={headerComponent}
                        LinkProps={LinkProps}
                        LinkDropdownStackProps={LinkDropdownStackProps}
                        LinkGroupHeaderTypographyProps={LinkGroupHeaderTypographyProps}
                        LinkGroupItemsTypographyProps={LinkGroupItemsTypographyProps}
                        LinkGroupHeaderLinkProps={LinkGroupHeaderLinkProps}
                        relativeLinkComponent={relativeLinkComponent || link.relativeLinkComponent}
                    />
                )
            })}
        </Stack>
    )
}
